import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initSecurity } from './utils/security'; // Correctly import initSecurity

// Initialize security measures
initSecurity();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Disable web vitals reporting in production
if (process.env.NODE_ENV === 'production') {
  reportWebVitals(() => {});
}